import {
  DOWNLOAD_REPORT_REQUEST,
  DOWNLOADING_REPORT_SUCCEEDED,
  DOWNLOADING_REPORT_FAILED,
} from "constants/actionTypes";

const initState = {
  downloading: false,
  success: false,
  error: null,
};

function reportsReducer(state = initState, action) {
  switch (action.type) {
    case DOWNLOAD_REPORT_REQUEST: {
      return Object.assign({}, state, { ...state, downloading: true });
    }
    case DOWNLOADING_REPORT_SUCCEEDED: {
      return Object.assign({}, state, {
        ...state,
        downloading: false,
        success: true,
        error: null,
      });
    }
    case DOWNLOADING_REPORT_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : null;

      return Object.assign({}, state, {
        ...state,
        downloading: false,
        success: false,
        error: error,
      });
    }

    default:
      return state;
  }
}

export { reportsReducer };
